import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/xiulian", label: "修炼体系" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || open ? "bg-background-50/95 backdrop-blur border-b border-background-200/70" : "bg-background-50/70 backdrop-blur"
      }`}
    >
      <nav className="container-site flex h-16 items-center justify-between" aria-label="主导航">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-leaf-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="font-heading text-lg font-bold text-foreground-950">天才医仙漫画</span>
        </Link>

        <div className="hidden items-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `rounded-md px-4 py-2 text-sm transition-colors ${
                  isActive
                    ? "bg-primary-100 text-primary-800 font-medium"
                    : "text-foreground-700 hover:bg-background-200/70 hover:text-foreground-950"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <Link
          to="/xiulian"
          className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 md:inline-flex"
        >
          查修炼脉络
        </Link>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? "关闭菜单" : "打开菜单"}
          aria-expanded={open}
          className="flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-200/70 md:hidden"
        >
          <i className={`${open ? "ri-close-line" : "ri-menu-line"} text-xl`} aria-hidden="true"></i>
        </button>
      </nav>

      {open && (
        <div className="border-t border-background-200/70 bg-background-50/95 px-4 pb-4 pt-2 backdrop-blur md:hidden">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-2.5 text-sm transition-colors ${
                    isActive ? "bg-primary-100 font-medium text-primary-800" : "text-foreground-800 hover:bg-background-200/70"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/xiulian"
              className="mt-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-center text-sm font-medium text-background-50 hover:bg-primary-600"
            >
              查修炼脉络
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}